import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getIdData } from "../../../lib/studentinfo";

export default function StudentTopMenu({ slug, activeMenu }) {
  //const [studentInfo, setStudentInfo] = useState(0);
  const [isStudent911, setisStudent911] = useState(false);
  const [isStudent12, setisStudent12] = useState(false);


  async function GetData() {
    const info = await getIdData(slug);
    //setStudentInfo(info[0].class);
    if (info[0].role === "Student911") {
      setisStudent911(true);
    } else if (info[0].role === "Student12") {
      setisStudent12(true);
    }
  }

  useEffect(() => {
    GetData();
  }, []);

  return (
    <>
    {isStudent911 && (
    <div className="settings-widget2">
      <div className="settings-inner-blk">
        <div className="sell-course-head">
          <div className="sidebar-tag-labels">
            <ul className="list-unstyled justify-content-around p-2" style={{ fontSize: "14px" }}>

              <li>
                <Link
                  to={`/parent/parent-studenttask/${slug}`}
                  className={
                    activeMenu === "Task"
                      ? "fw-bolder text-decoration-underline  "
                      : ""
                  }
                >
                  Task
                </Link>
              </li>
              <li>
                <Link
                  to={`/parent/parent-studentagenda/${slug}`}
                  className={
                    activeMenu === "Agenda"
                      ? "fw-bolder text-decoration-underline  "
                      : ""
                  }
                >
                  Agenda
                </Link>
              </li>
              <li>
                <Link
                  to={`/parent/parent-studentschedule/${slug}`}
                  className={
                    activeMenu === "Schedule"
                      ? "fw-bolder text-decoration-underline"
                      : "text-center"
                  }
                >
                  Schedule
                </Link>
              </li>                               
              <li>
                <Link
                  to={`/parent/student-profile/${slug}`}
                  className={
                    activeMenu === "Profile"
                      ? "fw-bolder text-decoration-underline  text-center"
                      : "text-center"
                  }
                >
                  College Profile
                </Link>
              </li>                           
            </ul>
          </div>
        </div>
      </div>
    </div>
)}
{isStudent12 && (
    <div className="settings-widget2">
      <div className="settings-inner-blk">
        <div className="sell-course-head">
          <div className="sidebar-tag-labels">
            <ul className="list-unstyled justify-content-around p-2" style={{ fontSize: "14px" }}>
            <li className="bg-info-subtle">
                <Link
                  to={`/parent/parent-studenttask/${slug}`}
                  className={
                    activeMenu === "Task"
                      ? "fw-bolder text-decoration-underline  "
                      : ""
                  }
                >
                  Task
                </Link>
              </li>
            <li className="bg-info-subtle">
                <Link
                  to={`/parent/parent-studentagenda/${slug}`}
                  className={
                    activeMenu === "Agenda"
                      ? "fw-bolder text-decoration-underline  "
                      : ""
                  }
                >
                  Agenda 
                </Link>
              </li>
            <li className="bg-info-subtle">
                <Link
                  to={`/parent/parent-studentschedule/${slug}`}
                  className={
                    activeMenu === "Schedule"
                      ? "fw-bolder text-decoration-underline fs-5 text-center"
                      : "text-center"
                  }
                >
                  Schedule
                </Link>
              </li>                    
              <li className="bg-info-subtle">
                <Link
                  to={`/parent/student-profile_2/${slug}`}
                  className={
                    activeMenu === "Profile_2"
                      ? "fw-bolder text-decoration-underline  text-center"
                      : "text-center"
                  }
                >
                  Application Profile
                </Link>
              </li>                   
            </ul>
          </div>
        </div>
      </div>
    </div>
    )}
    </>
  );
}